import * as Yup from 'yup'
import {AddressValidSchema} from '../../../../coreGlobal/validation/AddressVali'
import {ContactValidSchema} from '../../../../coreGlobal/validation/ContactVali'
import {BankDataValidSchema} from '../../../../coreGlobal/validation/BankDataVali'
import {removeMonetaryMaskBr} from '../../../../utils/formatMonetaryToBr'

export const franchiseSchema = Yup.object().shape({
  name: Yup.string().required('Informe o nome da Franquia'),
  email: Yup.string().email('Digite um email válido').required('Insira o e-mail da Franquia'),
  document: Yup.string().required('Informe um documento').min(14, 'Minimo 14 caracteres'),
  person: Yup.object().shape({
    name: Yup.string().required('Insira a razão social'),
    juridicalPerson: Yup.object().shape({
      fantasyName: Yup.string().required('Insira o nome fantasia'),
    }),
  }),
  addresses: Yup.array().of(AddressValidSchema).required().min(1),
  contacts: Yup.array().of(ContactValidSchema).required().min(1),
  bankData: Yup.array().of(BankDataValidSchema),
})

export const franchiseStarSchema = Yup.array()
  .of(
    Yup.object().shape({
      description: Yup.string()
        .trim()
        .required('Nome é obrigatório')
        .max(255, 'Máximo de 255 caracteres'),

      observation: Yup.string()
        .nullable()
        .trim()
        .test(
          'min-if-filled',
          'Observação deve ter no mínimo 3 caracteres',
          (value) => !value || value.length >= 3
        ),

      minAmount: Yup.string().required('Valor mínimo obrigatório'),

      maxAmount: Yup.string()
        .required('Valor máximo obrigatório')
        .test('max-greater-min', 'Valor máximo deve ser maior que o mínimo', function (value) {
          const {minAmount} = this.parent

          const min = removeMonetaryMaskBr(minAmount)
          const max = removeMonetaryMaskBr(value)

          return max > min
        }),
    })
  )
  .test(
    'range-order',
    'O valor máximo deve ser menor que o mínimo da próxima faixa',
    function (stars) {
      if (!stars) return true

      for (let i = 0; i < stars.length - 1; i++) {
        const currentMax = removeMonetaryMaskBr(stars[i].maxAmount)
        const nextMin = removeMonetaryMaskBr(stars[i + 1].minAmount)

        if (currentMax >= nextMin) {
          return this.createError({
            path: `${i}.maxAmount`,
            message: 'Valor máximo deve ser menor que o mínimo da próxima faixa',
          })
        }
      }

      return true
    }
  )

export const franchiseConfigSchema = Yup.object().shape({
  startTime: Yup.string().when('type', {
    is: (val) => val === 2,
    then: () =>
      Yup.string()
        .matches(/^([01]\d|2[0-3]):([0-5]\d)$/, 'Formato de horário de início inválido')
        .required('O horário de início é obrigatório')
        .test(
          'is-after-end',
          'O horário de início não pode ser menor ou igual que o horário de término',
          function (startTime) {
            const {endTime} = this.parent
            if (!startTime || !endTime) {
              return true
            }
            const startTimeObj = startTime
            const endTimeObj = endTime
            return startTimeObj < endTimeObj
          }
        ),
  }),
  endTime: Yup.string().when('type', {
    is: (val) => val === 2,
    then: () =>
      Yup.string()
        .matches(/^([01]\d|2[0-3]):([0-5]\d)$/, 'Formato de horário de término inválido')
        .required('O horário de témino é obrigatório')
        .test(
          'is-after',
          'O horário de término deve ser maior que o horário de início',
          function (endTime) {
            const {startTime} = this.parent
            if (!startTime || !endTime) {
              return true
            }
            const startTimeObj = startTime
            const endTimeObj = endTime
            return startTimeObj < endTimeObj
          }
        ),
  }),
  acceptsRecurringProducts: Yup.boolean().required(
    'Informe se aceita pagamento recorrente para produtos'
  ),
  discountApprovalMode: Yup.string()
    .oneOf(['token', 'review'], 'Selecione um modo de aprovação de desconto válido')
    .required('Selecione o modo de aprovação de desconto'),
})

export const franchiseApiPricingSchema = Yup.array().of(
  Yup.object().shape({
    endpoint: Yup.string()
      .trim()
      .required('Nome é obrigatório')
      .max(255, 'Máximo de 255 caracteres'),

    notes: Yup.string()
      .nullable()
      .trim()
      .test(
        'min-if-filled',
        'Observação deve ter no mínimo 3 caracteres',
        (value) => !value || value.length >= 3
      ),

    pricePerRequest: Yup.string()
      .required('Valor  obrigatório')
      .test('greater-than-zero', 'Valor deve ser maior que zero', (value) => {
        if (!value) return false

        const formattedValue = value
          .replace(/[R$\s]/g, '')
          .replace(/\./g, '')
          .replace(',', '.')

        const numberValue = parseFloat(formattedValue)

        return !isNaN(numberValue) && numberValue > 0
      }),

    validFrom: Yup.string().required('Valor  obrigatório'),
  })
)
